const setDocuemntTtitle = title => {
  if (window.nfplusJsbridge) {
    window.nfplusJsbridge.setTitleBarAttribute({ title })
  }
  document.title = title
}

export default setDocuemntTtitle
